import React, {ReactElement} from 'react';
import {ServiceBase} from '../ServiceBase';
import {
    IGermanyResponsibleGamingButtonOptions,
    IOrbitComponentInSdk,
    IOrbitComponentToSdkAdapterService, IOrbitDialogInSdk
} from '../../../common/interfaces/orbit-component-to-sdk-adapter/orbit-component-to-sdk-adapter.service.interface';
import { ITimeSpentReminderOptions } from '../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/time-spent-reminder-options';
import {IPartyJackpotInGameWidgetComponentProps} from '../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/party-jackpot-ingame-widget.component-props';
import {PartyJackpotInGameWidgetComponent} from '../../components/party-jackpot-ingame-widget/party-jackpot-ingame-widget.component';
import {IShowPartyJackpotWelcomePopupOptions} from '../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/show-party-jackpot-welcome-popup-options';
import {
  ResponsibleGamingButtonsGermanyComponent
} from "../../components/responsible-gaming-buttons/germany/responsible-gaming-buttons-germany.component";
import {action, observable} from 'mobx';
import {IOrbitComponentsInsideSdkProvider, IComponentRenderedInsideSdk} from './orbit-components-inside-sdk-provider.interface';
import {TimeSpentReminderComponent} from "../../components/time-spent-reminder/time-spent-reminder.component";
import {ShowModalOptions} from "../dialog/dialog.service.interface";
import {StatePopupComponent} from "../../components/state-popup/state-popup.component";
import {IStatePopupOptions} from "../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/state-popup.component-props";

export class OrbitComponentToSdkAdapterService extends ServiceBase implements IOrbitComponentToSdkAdapterService, IOrbitComponentsInsideSdkProvider {
    renderPartyJackpotInGameWidget(element: HTMLElement, props: IPartyJackpotInGameWidgetComponentProps): IOrbitComponentInSdk {
        return this._renderComponent(element,
                <PartyJackpotInGameWidgetComponent key={'PartyJackpotInGameWidget'} {...props}/>
            );
    }
    renderGermanyResponsibleGamingButtons(element: HTMLElement, options?:IGermanyResponsibleGamingButtonOptions): IOrbitComponentInSdk{
        return this._renderComponent(element,
            <ResponsibleGamingButtonsGermanyComponent key={'GermanyResponsibleGamingButtons'} placement={options?.placement}/>);
    }

    showPartyJackpotWelcomePopup(options: IShowPartyJackpotWelcomePopupOptions): IOrbitDialogInSdk {
        return this.services.partyJackpot.showPartyJackpotWelcomePopup(options);
    }

    showLocationPopup(props: IStatePopupOptions) {
        return this.services.dialog.showModal(dialogHandler =>
                <StatePopupComponent
                    dialogHandler={dialogHandler}
                    onStateSelect={props.onStateSelect}
                    headerText={this.services.translation.translate("STATE_POPUP_HEADER")}
                    onStateNotInListClick={props.onStateNotInListClick}
                />, {
                title: this.services.translation.translate("STATE_POPUP_TITLE"),
                forceTransparentBackground: true,
                disableFullscreenMode: true,
                forceCentralization: true,
                mobileCenterHeader: true,
                isHighPriority:  true,
                onClosed: props.onMessageClosed,
                shouldBeClosedOnlyByUser: true
            }
        );
    }

    showTimeSpentReminder(options: ITimeSpentReminderOptions): IOrbitDialogInSdk {

        const dialogOptions: ShowModalOptions = {
            title: this.services.translation.translate("TSR_TITLE"),
            forceTransparentBackground: true,
            disableFullscreenMode: true,
            forceCentralization: true,
            mobileCenterHeader: true,
            isHighPriority:  true,
            onClosed: null,
            shouldBeClosedOnlyByUser: true,
            hideCloseButton: true,
            headerClass: 'cy-uk-malta-reality-check-title',
            showPopupAboveSecondWebViewHybrid: true
        };

        return this.services.dialog.showModal(dialogHandler => <TimeSpentReminderComponent
            {...options}
            dialogHandler={dialogHandler}/>
            , dialogOptions );
    }

    @observable.ref currentRenderedComponents: IComponentRenderedInsideSdk[] = [];

    @action
    private _setCurrentRenderedComponents(currentRenderedComponents: IComponentRenderedInsideSdk[]) {
        this.currentRenderedComponents = currentRenderedComponents;
    }

    private _unmountComponent(element: HTMLElement) {
        const index = this.currentRenderedComponents.findIndex(item => item.element === element);
        if(index >= 0) {
            this._setCurrentRenderedComponents([...this.currentRenderedComponents.splice(index, 1)])
        }
    }

    private _renderComponent(element: HTMLElement, component: ReactElement): IOrbitComponentInSdk {

        this._setCurrentRenderedComponents([
            ...this.currentRenderedComponents,
            {
                component: component,
                element: element
            }
        ]);

        return {
            unmount: () => {
                this._unmountComponent(element)
            }
        }
    }

}